
export interface Country {
    country_id: number;
    country_name: string;
}
export interface ListPagesDB {

//{"id":76,"country_id":"3","owned":"1","channel_id":"1871811544","name":"TestGroup","access_hash":"-2373341697583675322","language_id":"3","country":{"country_id":3,"country_name":"Germany"}},
    id: number;
    country_id: number;
    owned: number;
    channel_id: string;
    name: string;
    language_id: string;
    country: Country;
}

export const LISTPAGEDB: ListPagesDB[] = [];
